import React, { useContext, useEffect, useState } from 'react'
import { Link, NavLink, useHistory } from 'react-router-dom'
import Layout from '../Layout'
import ReactHtmlParser from 'react-html-parser'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'
import './static.css'
import AuthContext from '../../../Product/context/auth/authContext'
import UserContext from '../../../Product/context/user/userContext'
import AlertContext from '../../../Product/context/alert/alertContext'
import { jsonToFormData } from '../../../Product/common/components'
import { handleRedirectInternal } from '../../../Product/common/components'

export default function Location(props) {
    const authContext = useContext(AuthContext)
    const userContext = useContext(UserContext)
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const { user, isAuthenticated, loadUser } = authContext
    let { editProfile } = userContext
    const [email, setEmail] = useState('')
    const history = useHistory()
    const isBuyBestProject = global.storeConfigration?.bodyClass2?.value === 'buyBestProject'
    useEffect(() => {
        if (user) {
            setEmail(user?.email)
        }
    }, [user])

    const handleSubscribe = () => {
        if (!isAuthenticated) {
            handleRedirectInternal(history, 'sign-up')
            return
        } else {
            if (
                String(email)
                    .toLowerCase()
                    .match(
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    )
            ) {
                editProfile(
                    jsonToFormData({
                        first_name: user.first_name,
                        last_name: user.last_name,
                        email: user.email,
                        phone: user.phone,
                        country: user.country,
                        state: user.state,
                        city: user.city,
                        address1: user.address1,
                        address2: user.address2,
                        zip: user.zip,
                        role: user.role,
                        company_name: user.company_name,
                        auction_io: 1,
                        subscribed: true,
                    }),
                    'footer',
                )
                setTimeout(() => loadUser(), 2000)
            } else if (email.length <= 0) {
                setAlert('Please Enter Email ID!', 'error')
            } else {
                setAlert('Invalid Email!', 'error')
            }
            return
        }
    }
    return (
        <>
            <SEOTAG page="Location" />
            <Layout props={props}>
                <div className="px-5 py-4 stctPgWrpr locationPage">
                    {/* <span>{ReactHtmlParser(global.storeDetails.seller_info)}</span> */}
                    <meta
                        name="description"
                        content="Our bin store offers deeply discounted items from major retailers. Products are placed in bins and the price you pay depends on the day you shop—higher on restock day, and dropping daily after that. It’s a fun, first-come-first-served treasure hunt!"
                    />

                    <div className="gfContactBanner titLoc">
                        <h2 className="bannertext">Locations</h2>
                    </div>

                    <section className="sectionContainer nearTxe">
                        <h4 className="binsTit">
                            Find a {isBuyBestProject ? 'Buy Best 4 Less' : 'Retail Rush'} Near You!
                        </h4>

                        <div className="binsDescBox">
                            <h4>Local Auction Pickups. National-Scale Savings.</h4>

                            <p className="pTag">
                                Welcome to the future of smart shopping! At{' '}
                                {isBuyBestProject ? 'Buy Best 4 Less' : 'Retail Rush'}, you get
                                name-brand products, steep discounts, and the convenience of local
                                pickup&mdash;all in one place. As we expand nationwide, you&rsquo;ll
                                always have a trusted destination for incredible deals close to
                                home.
                            </p>
                        </div>
                    </section>

                    <div className="sectionContainer">
                        <div className="binsDescBox mobileBins">
                            <div className="mobFull">
                                <section className="sectionContainer picLoc">
                                    <h4 className="binsTit">
                                        {isBuyBestProject ? 'Fredericksburg, VA' : 'Columbus, OH'}{' '}
                                        &ndash; Our Flagship Location
                                    </h4>

                                    <div className="binsDescBox noBorder">
                                        <p className="pTag">
                                            {isBuyBestProject
                                                ? '18 Blackjack Road, Suite 101, Fredericksburg, VA, 22405'
                                                : '4645 Morse Centre Road, Columbus, OH 43229'}
                                        </p>

                                        <p className="pTag">
                                            <b>Phone: </b>
                                            {isBuyBestProject ? '+1 571-426-0160' : '380-500-2023'}
                                        </p>
                                    </div>
                                </section>

                                <section className="sectionContainer PickHrs">
                                    <h4 className="binsTit">Hours</h4>

                                    <div className="binsDescBox noBorder">
                                        <ul className="listPoints">
                                            <li>
                                                <span>Monday:</span> Closed
                                            </li>
                                            <li>
                                                <span>Tuesday:</span> 12pm - 7pm
                                            </li>
                                            <li>
                                                <span>Wednesday:</span> 12pm - 7pm
                                            </li>
                                            <li>
                                                <span>Thursday:</span> 12pm - 7pm
                                            </li>
                                            <li>
                                                <span>Friday:</span> 12pm - 7pm
                                            </li>
                                            <li>
                                                <span>Saturday:</span> 12pm - 7pm
                                            </li>
                                            <li>
                                                <span>Sunday:</span> Closed
                                            </li>
                                        </ul>
                                    </div>
                                </section>
                            </div>

                            <section className="sectionContainer mobFull mAp">
                                <div className="map-container">
                                    <iframe
                                        allowfullscreen=""
                                        height="550"
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        src={
                                            isBuyBestProject
                                                ? 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3083.8889591235135!2d-77.44462711519908!3d38.38498767658488!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b108240e3e27bb%3A0xc33d147478592617!2s18+Blackjack+Rd+%23101%2C+Fredericksburg%2C+VA+22405%2C+USA!5e0!3m2!1sen!2sus!4v1753708373490!5m2!1sen!2sus'
                                                : 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d763.3960855282165!2d-82.96443800000002!3d40.062376!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88388bc7e5a608f1%3A0x989c19f27cf7c1a!2sRetail%20Rush!5e0!3m2!1sen!2sus!4v1753705578924!5m2!1sen!2sus'
                                        }
                                        style={{ border: '0' }}
                                        width="100%"
                                    ></iframe>
                                </div>
                            </section>
                        </div>
                    </div>

                    <section className="sectionContainer w100 cmngSoon">
                        <h4 className="binsTit">New Locations Coming Soon</h4>

                        <div className="binsDescBox noBorder">
                            <p>
                                We&rsquo;re just getting started! Our goal is to launch multiple
                                locations across the U.S., bringing these savings to more
                                communities. Want to be the first to know when we land near you?
                                Stay connected and sign up for emails.
                            </p>
                        </div>

                        <div className="ftrWrprVw greenFieldFooter locationPg">
                            <div className="footerSubcription">
                                {!user?.subscribed ? (
                                    <div className="headerSearchField">
                                        <input
                                            type="text"
                                            name="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            className="nav-standard-top-area-search-input open-sans"
                                            placeholder="Email Address"
                                        />
                                        <button
                                            className="filterUserSearch lin lin-magnifier nav-standard-top-area-search-sumbit"
                                            onClick={() => handleSubscribe()}
                                        >
                                            Subscribe
                                        </button>
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                    </section>
                </div>
            </Layout>
        </>
    )
}
